export type App = 'confluence' | 'projects';

export const ALL_APPS: App[] = ['confluence', 'projects'];

export const parseAppParam = (param?: string): App[] => {
	const list = (param ?? '').split(',');
	return list.filter(item => ALL_APPS.includes(item as App)) as App[];
};

export const encodeAppParam = (apps: App[]): string => {
	return apps.join(',');
};

export const APP_QUERY_PARAM = 'app';
